import {Box, Stack, Card, Typography, CardHeader, Avatar, Grid} from '@mui/material';
import StorageIcon from "@mui/icons-material/Storage";
import {useCallback, useEffect, useState} from "react";
import {useDataProvider} from "react-admin";

const  ServerItem = ({ servers }) => {
    const { server_address, updated_at, rating } = servers;

    return (
        <Stack direction="row" alignItems="center" spacing={2} display='flex'>
            <Avatar style={{backgroundColor : '#2E8BC0'}}>
                <StorageIcon />
            </Avatar>
            <Box sx={{ minWidth: 500 }}>
                    <Typography variant="subtitle2" noWrap>
                        {server_address}
                    </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                    Updated : {((Date.now() - new Date(updated_at).getTime())/1000) > 60 ? `${Math.round(((Date.now() - new Date(updated_at).getTime()) / 1000) / 60)} minutes ago` : `${(Date.now() - new Date(updated_at).getTime()) / 1000} seconds ago`}
                </Typography>
            </Box>
            <Typography variant="body2" sx={{ pr: 3, flexShrink: 0, color: `${rating > 50 ? "red" : "green"}` , textAlign : 'right' }}>
                {rating}%
            </Typography>
        </Stack>
    );
}
const Servers = () => {
    const dataProvider = useDataProvider();
    const [servers , setServers] = useState([]);
    const fetchServerData = useCallback(async () => {
        await dataProvider.getList(
            'servers',
            {
                pagination: { page: 1, perPage: 5 },
                sort: { field: 'title', order: 'ASC' },
                filter: {}
            },{
                onSuccess: async (response) => {
                    setServers(response.data);
                }
            }
        )
    } , []);

    useEffect(() => {
        fetchServerData();
    }, [])

    return (
        <div style={{paddingTop : 28 }}>
            <Card
                style={{
                    height: "50vh",
                }}
            >
                <CardHeader title="Servers" style={{textAlign : 'center'}} />
                {servers.length !== 0 ?
                    <Stack spacing={5} sx={{ p: 3, pr: 0 }}>
                        {servers.map((servers) => (
                            <ServerItem servers={servers} />
                        ))
                        }
                    </Stack>
                    :
                    <div style={{
                        height: "37vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <Grid item md={6} style={{justifyContent : 'center' , alignContent : 'center' , display: 'grid'}}>
                            <Stack direction='row' spacing={2} style={{alignItems : 'center' , fontSize : 23}}>
                                <StorageIcon style={{fontSize : 30}}/>
                                <Typography variant='inherit'>
                                    No data available
                                </Typography>
                            </Stack>
                        </Grid>
                    </div>
                }
            </Card>
        </div>

    )
}
export  default Servers;